import { ApplicationActions, ROBOT_TEMPLATES } from './constants';

const DEFAULT_NEW_PROJECT_TEMPLATE_KEY = 'custom_bot';

export function getNewProjectDialog() {
  const customFrameworkTemplate = ROBOT_TEMPLATES.find((template) => template.key === DEFAULT_NEW_PROJECT_TEMPLATE_KEY);

  return {
    ...ApplicationActions.Dialogs.PROJECT_NAME,
    options: {
      ...ApplicationActions.Dialogs.PROJECT_NAME.options,
      title: 'projectNameDialog.new.title',
      projectTemplate: customFrameworkTemplate?.key ?? null,
      rapidRobotCode: customFrameworkTemplate?.shareCode ?? null,
    },
  };
}
